module.exports = __webpack_public_path__ + "static/media/template.d1e8b43d.xlsx";